import React, { useState, useEffect } from 'react';

// Универсальный SegmentSwitch:
// - если передан prop active → управляемый режим
// - если active не передан → хранит состояние внутри
export default function SegmentSwitch({ active, onChange }) {
    const [internalActive, setInternalActive] = useState(active || 'promo');

    // Синхронизация, если родитель меняет active
    useEffect(() => {
        if (active && active !== internalActive) {
            setInternalActive(active);
        }
    }, [active, internalActive]);

    const current = active || internalActive;

    const handleClick = (key) => {
        if (onChange) {
            onChange(key);
        }
        if (!active) {
            setInternalActive(key);
        }
    };

    return (
        <div className="w-[160px] h-[33px] bg-[#1D1D1D] rounded-full flex p-[2px]">
            {/* Promo */}
            <button
                onClick={() => handleClick('promo')}
                className={`flex justify-center items-center px-[20px] py-[7px] rounded-full font-semibold text-[14px] leading-[18px] ${
                    current === 'promo'
                        ? 'bg-[#3B3836] text-[#EAEAEA]'
                        : 'text-[#959595]'
                }`}
            >
                Promo
            </button>

            {/* Game */}
            <button
                onClick={() => handleClick('crystals')}
                className={`flex justify-center items-center px-[20px] py-[7px] rounded-full font-semibold text-[14px] leading-[18px] ${
                    current === 'crystals'
                        ? 'bg-[#3B3836] text-[#EAEAEA]'
                        : 'text-[#959595]'
                }`}
            >
                Game
            </button>
        </div>
    );
}
